import React, { useState } from 'react';
import { ReactComponent as GoogleLogo } from '@/assets/icons/googleLogo.svg';
import { ReactComponent as EmailLogo } from '@/assets/icons/emailLogo.svg';
import { Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import Utils from '@/utils/index';
import axios from 'axios';
import { api_config } from '../../../../constants/api';
import { googleCallback } from '../../../../api/apis';
import { useGoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { pidMap } from '../../../../ga/index';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../redux/action';
export default function InitState(props) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['userLoginTips']);
  const dispatch = useDispatch();
  const reducerData = useSelector((state) => state.work);
  const onSuccessCallback = (response) => {
    console.log('response', response);
    dispatch(
      action.onSignUpModal({
        visible: false,
      })
    );
    axios({
      method: 'get',
      url: api_config.googleUrl + 'google/state',
      params: {
        pid: pidType[Utils.getLanguage()],
        token: '$2y$10$NCD4zFjrZzJvKN7YSyXIQOb/ivtITqcFKh6c08ZZ80XSGdHXdZdt.',
        redirect_uri: window.location.origin,
      },
    })
      .then((obj) => {
        console.log(obj);
        if (obj.data.code === 200) {
          googleCallback({
            code: response.code,
            state: obj.data.data.state,
          }).then((obj) => {
            if (obj.code === 200) {
              let hostname = window.location.hostname;
              Cookies.set('authorization', obj.data.authorization, {
                expires: 30,
              });
              Cookies.set('access_token', obj.data.account_access_token, {
                expires: 30,
                domain: hostname.substring(
                  hostname.indexOf('.'),
                  hostname.length
                ),
              });
              let expires_in = new Date().getTime() + 30 * 86400 * 1000;
              Cookies.set('access_token_expires_in', expires_in.toString(), {
                expires: 30,
                domain: window.location.hostname.substring(
                  window.location.hostname.indexOf('.'),
                  window.location.hostname.length
                ),
              });

              dispatch(action.onAuthorizationChange(obj.data.authorization));

              if (reducerData.work === 'dynamic-photo') {
                dispatch(action.onExceed2M({ visible: true }));
              }
            }
            if (obj.code === 403101) {
              dispatch(
                action.onSignUpModal({
                  visible: true,
                  step: 6,
                })
              );
              dispatch(
                action.saveEmail({
                  email: obj.data.email,
                })
              );

              localStorage.setItem('googleId', obj.data.id);
            }
            if (obj.code === 403102) {
              dispatch(
                action.onSignUpModal({
                  visible: true,
                  step: 2,
                })
              );
              message.error(t('403102'));
            }
            let result = window.location.href.split('?');
            if (result.length > 2) {
              window.history.replaceState({}, '', result[0] + '?' + result[1]);
            } else {
              window.history.replaceState({}, '', result[0]);
            }
          });
        }
      })
      .catch((err) => {
        message.warn(t('common:Network Error'));
      });
  };

  const GoogleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => onSuccessCallback(codeResponse),
    flow: 'auth-code',
  });

  const pidType = {
    en: 4011, //en 1
    br: 4068, //pt 葡萄牙语 1
    fr: 4072, //fr 1
    it: 4070, //it 1
    ru: 4071, //ru 1
    ar: 4069, //ar 1
    es: 4073, //es 1
    // tr: 4080, //tr
    kr: 4067, //ko 1
    jp: 4076, //ja 1
    nl: 4074, //nl 1
    de: 4075, //de 1
    tw: 4077, //tw 1
    inn: 4078, //hi 1
    id: 4079, //id 1

    // ar, cn, en, id, inn, kr, br, jp, tw, it, fr, ru, es, de, nl
  };
  const videoTimes = Cookies.get('videoEditorTimes') || 0;

  const EmailLogin = () => {
    props.changeStep(2);
  };

  const linkToService = () => {
    window.open(Utils.getHitPawServiceLink());
  };

  const linkToPrivacy = () => {
    window.open(Utils.getHitPawPrivacy());
  };

  return (
    <div className='initState'>
      <div className='header'>
        <div className='loginTitle'>{t('Afewsecondsaway')}</div>
      </div>

      <div className='loginBtn'>
        <Button
          onClick={GoogleLogin}
          className='googleBtn'
          type='default'
          loading={loading}
          block
        >
          <GoogleLogo className='googleIcon' />
          <div className='btnContent'>{t('ContinuewithGoogle')}</div>
        </Button>

        <Button onClick={EmailLogin} className='emailBtn' type='default' block>
          <EmailLogo className='emailIcon' />
          <div className='btnContent'>{t('ContinuewithEmail')}</div>
        </Button>
      </div>
      <div className='serviceAndPolicy'>
        <div className='serviceContainer'>
          {t('Byproceedingyouagreetoour')}
          <span onClick={() => linkToService()} className='serviceLink'>
            {t('ServicesofUse')}
          </span>
          {t('and')}
          <span onClick={() => linkToPrivacy()} className='serviceLink'>
            {t('PrivacyPolicy')}
          </span>
        </div>
      </div>
    </div>
  );
}
